import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import axios from "axios";
import { toast } from "sonner";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setAuthData } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCode = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const state = params.get("state");
      const errorParam = params.get("error");
      const savedState = sessionStorage.getItem("google_oauth_state");

      if (errorParam) {
        toast.error("Google sign-in cancelled");
        navigate("/", { replace: true });
        return;
      }

      if (!code || !state || state !== savedState) {
        toast.error("Sign-in verification failed");
        navigate("/", { replace: true });
        return;
      }

      sessionStorage.removeItem("google_oauth_state");

      try {
        const response = await axios.post(`${API}/auth/google`, {
          code,
          redirect_uri: window.location.origin + "/auth/google"
        });
        const { access_token, user } = response.data;
        setAuthData(access_token, user);
        navigate("/overview", { replace: true });
      } catch (error) {
        console.error("Google auth failed:", error);
        toast.error(error.response?.data?.detail || "Google sign-in failed");
        navigate("/", { replace: true });
      }
    };

    processCode();
  }, [navigate, setAuthData]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="animate-pulse flex flex-col items-center" data-testid="google-auth-loading">
        <img src="/thrively-logo.png" alt="Thrively" className="h-16 w-auto mb-4" />
        <span className="text-primary font-heading font-bold">Signing you in with Google...</span>
      </div>
    </div>
  );
}
